import React from 'react';
import PropTypes from 'prop-types';
import Table from 'semantic-table-grid';

export class ResumeDataTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      areDataLoading: false,
    };
  }

  resumeDataColumns = [
    {
      key: 'agenciesNumber',
      name: <div style={{ textAlign: 'center' }}>Agenzie </div>,
      formatter: ({ data }) => <div style={{ textAlign: 'center' }}>{data.agencyNumber}</div>,
    },
    {
      key: 'collaboratoriNumber',
      name: <div style={{ textAlign: 'center' }}>Collaboratori </div>,
      formatter: ({ data }) => <div style={{ textAlign: 'center' }}>{data.collaboratori}</div>,
    },
    {
      key: 'tutorNumber',
      name: <div style={{ textAlign: 'center' }}>Tutor</div>,
      formatter: ({ data }) => <div style={{ textAlign: 'center' }}>{data.tutor}</div>,
    },
    {
      key: 'cordinatriciNumber',
      name: <div style={{ textAlign: 'center' }}>Coordinatrici</div>,
      formatter: ({ data }) => <div style={{ textAlign: 'center' }}>{data.coordinatrici}</div>,
    },
  ];

  render() {
    return (
      <Table
        columns={this.resumeDataColumns}
        elements={[this.props.resumeData]}
        isLoading={this.props.areResumeDataLoading}
      />
    );
  }
}

ResumeDataTable.propTypes = {
  areResumeDataLoading: PropTypes.bool,
  resumeData: PropTypes.object,
};

export default ResumeDataTable;



// WEBPACK FOOTER //
// ./app/components/NetworkDashboard/ResumeDataTable/index.js